

export const LINK_TO_UNPUBLISHED_CASELET_IN_PDF = import.meta.env.VITE_BASE_LINK_TO_CASELET_IN_PDF + "/#/unpublished-caselets"
export const LINK_TO_PUBLISHED_CASELET_IN_PDF = import.meta.env.VITE_BASE_LINK_TO_CASELET_IN_PDF + "/#/caselets";
export const Chat: string = "chat";
export const Seed: string = "seed";
export const caselet: string = "caselet";
export const unPublishCaselet: string = "un-publish-caselet";
export const caseletView: string = "2";
export const loadNumberOfFiles = 5;
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;
export const BaseURL = import.meta.env.VITE_APP_API_URL;
export const PRIVATE_CONTENT = "private-content";
export const BASE_FRONT_END_URL =  import.meta.env.VITE_BASE_FRONT_END_LINK + '/#/'
export const APP_NAME = "PowerGuide"